var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.star, ( _obj = {}, _obj[_vm.$style.blue] = _vm.color === 'blue', _obj )],style:({
    'background-position-x': _vm.backgroundPositionX,
    width: (_vm.size + "px"),
    height: (_vm.size + "px"),
    'background-color': _vm.bgColor,
  })})}
var staticRenderFns = []

export { render, staticRenderFns }